/* tslint:disable */

/**
 */
export class Position {
    x1?: number;
    y1?: number;
    x2?: number;
    y2?: number;
    position?: number;
    textX?: number;
    textY?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/position.ts